export default __webpack_public_path__ + "static/media/placeholder_dummy2016-hilfsprojekt01-de-mobile.79c3e749.png";